// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dOF7","right":"styles_right__3HeEZ"};